import { useCallback } from 'react';
import { css } from '@emotion/react';
import {
  LocationHistoryTray,
  LocationServiceLocationItem,
  useLocationHistory,
  useLocationService,
  usePinnedLocations,
} from '@frontend/wam-location-service';
import { theme } from '@frontend/theme';

export type RecentlyVisitedTrayProps = {
  onClose: () => void;
};

const styles = {
  trayWrapper: css({
    margin: `-${theme.spacing(4)}`,
    height: '105%',
  }),
};

export const RecentlyVisitedTray = ({ onClose }: RecentlyVisitedTrayProps) => {
  const { currentLocation, setCurrentLocationId } = useLocationService();

  const {
    locations: recentLocations,
    addLocation: addRecentLocation,
    removeLocation: removeRecentLocation,
  } = useLocationHistory();
  const { locations: pinnedLocations, removeLocation: removePinnedLocation } = usePinnedLocations();

  const onChangeLocation = useCallback(
    (location: LocationServiceLocationItem) => {
      setCurrentLocationId(location.locationId);
      addRecentLocation(location);
    },
    [addRecentLocation]
  );

  return (
    <div css={styles.trayWrapper}>
      <LocationHistoryTray
        onClose={onClose}
        location={currentLocation}
        recentLocations={recentLocations}
        pinnedLocations={pinnedLocations}
        onChangeLocation={onChangeLocation}
        onRemovePinnedLocation={removePinnedLocation}
        onRemoveRecentLocation={removeRecentLocation}
      />
    </div>
  );
};
